import { jsx as o } from "react/jsx-runtime";
import { useChatbotContext as s } from "../../hooks/useChatbotContext.js";
function a(t) {
  const { cn: e } = s();
  return /* @__PURE__ */ o(
    "div",
    {
      ...t,
      className: e("flex w-full grow flex-col items-stretch", t.className)
    }
  );
}
export {
  a as BotMessageContainer
};
